module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/@covalent/core/common/styles/font/MaterialIcons-Regular.woff2
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.woff2
// module chunks = 2